<div elementDataTest="subtitlesItemElement" class="d-flex align-items-center">
    <div class="language-box">
        <app-upload-subtitles-language
            [languageControl]="newLanguageControl"
            [subtitlesStatusControl]="subtitlesStatusControl"
            [subtitlesEnabledControl]="subtitlesEnabledControl"
        ></app-upload-subtitles-language>
    </div>
    <div [style.max-width.rem]="13" class="w-100" *ngIf="!hasHash && !fileName">
        <app-subtitles-uploader [formControl]="fileControl"></app-subtitles-uploader>
    </div>
    <div *ngIf="fileName" class="uploaded-subtitles-name text-xs font-bold border border-grey-v6 text-grey-v6 flex-grow-1 text-oneline">{{ fileName }}</div>
    <div class="theme-new d-flex">
        <bbutton
            *ngIf="downloadSubtitlesUrl?.length > 0"
            (click)="downloadSubtitles()"
            class="btn border border-grey-v6 btn-download p-1"
            buttonDataTest="downloadSubtitlesButton"
        >
            <div ariaHidden class="icon icon-download icon-grey-v6" inlineSVG="assets/icons.svg#download-2"></div>
        </bbutton>
        <button
            *ngIf="hasHash || downloadSubtitlesUrl?.length > 0"
            (click)="remove()"
            class="btn border border-grey-v6 bg-white btn-remove p-1"
            buttonDataTest="removeSubtitlesButton"
        >
            <div ariaHidden class="icon icon-remove icon-grey-v6" inlineSVG="assets/icons.svg#trash-alt"></div>
        </button>
    </div>
</div>
